"use client";
import React, { useState } from "react";
import styled from "styled-components";
import GlobalSizeStyled from '../../styles/global_size.scss';
import StartButton from "./StartButton";
import BasicButton from "@/Common/ButtonsV2/BasicButton";
import { ROUTE_PATH } from "@/utils/Global";
import { Trans } from "react-i18next";
import i18n from "@/i18n";
import VideomonsterHeroContent from "./VideomonsterHeroContent";

const HeroSection = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 30px;
  position: relative;
  min-height: 470px;
  min-width: ${GlobalSizeStyled.DEFAULT_ROOT_AREA_MIN_WIDTH};
  width: 100%;
  aspect-ratio: 2.936;
  max-width: 2000px;
  overflow: hidden;
  align-items: center;
  font-size: 14px;
  color: rgba(0, 250, 249, 1);
  font-weight: 300;
  white-space: nowrap;
  text-align: center;
  letter-spacing: -0.28px;
  line-height: 1.3;
  justify-content: end;

  @media (max-width: 991px) {
    padding: 100px 20px;
    white-space: initial;
  }
`;

const VideoWrapper = styled.div`
    width: calc(100% - 40px);
    height: calc(100% - 10px);
    object-fit: cover;
    z-index: 0;
    margin: 5px 20px;
    border-radius: 20px;
    overflow: hidden;
`;

const Video = styled.video`
  inset: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
`;

const Thumbnail = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
`

export default function VideoMonsterHero({ history }) {
  const [isLoaded, setIsLoaded] = useState(false)

  const handleStartButtonClick = () => {
    history.push(ROUTE_PATH.DESIGN_SELECT)
  }

  return (
    <>
      <HeroSection>
        <VideoWrapper>
          <Video
            src={"https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2025/1_banner_pc.mp4"}
            muted
            autoPlay
            loop
            playsInline
            webkit-playsinline
            onLoadedData={() => setIsLoaded(true)}
          />
          <Thumbnail
            style={{ display: isLoaded ? "none" : "block" }}
            src={"https://front.videomonster.com/images-7cuytg20/web/v2/landing2025/1_banner_pc.jpg"}
          />
          {/* <StartButtonWrapper onClick={handleStartButtonClick}>
            <IconImage src="https://front.videomonster.com/images-7cuytg20/web/v2/landing2025/play-button.svg" alt="Icon" />
            <StartButton text="시작하기" />
          </StartButtonWrapper> */}
        </VideoWrapper>
      </HeroSection>
      {/* <HeroContent history={history} /> */}
    </>
  );
}
